"use client";

import { Button } from "@/shared/components/ui/button/button.component";

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <>
    <div className="flex h-screen flex-col items-center justify-center gap-3 sm:gap-5 text-center mx-6">
      <h1 className="text-2xl sm:text-4xl">Ocorreu um problema ao carregar esta página</h1>
      <h2 className="text-lg sm:text-2xl">Você pode tentar novamente agora ou voltar mais tarde</h2>
      <Button
        id="btn-retry"
        color="secondary"
        onClick={reset}
        className="max-w-max"
      >
        Tentar novamente
      </Button>
    </div>
  </>
}

